module.exports = __webpack_public_path__ + "img/mp_rm@2x.d5b2f12b.png";